<template>
    <div class="ui form segment">
        <h3 class="ui header">
            Impostazioni Profilo
        </h3>
        <div class="ui hidden divider"></div>
        <div class="three fields">
            <div class="field">
                <label>Nome</label>
                <input type="text" v-model="user.name">
            </div>
            <div class="field">
                <label>Email</label>
                <input type="email" v-model="user.email">
            </div>
            <div class="field">
                <label>Username</label>
                <input type="text" v-model="user.username" readonly>
            </div>
        </div>
        <div class="sixteen wide column">
            <div id="success" class="ui positive hidden message">
                <div class="header">
                    Profilo Salvato!
                </div>
            </div>
            <div id="message" class="ui negative hidden message">
                <div class="header">
                    Attenzione!
                </div>
                <p>{{ message }}</p>
            </div>
        </div>
        <div class="sixteen wide column">
            <button type="button" class="ui positive button" @click="save">
                <i class="sync icon"></i>Aggiorna
            </button>
        </div>
    </div>
</template>
<script type="text/javascript">

import { mapState } from 'vuex'

export default{

    data: () => {
        return {
            message: '',
        }
    },

    computed: {
        ...mapState('app', ['user']),
    },

    methods: {
        save() {
            
            this.$store.dispatch( 'profile/save' ).then(response => {
                $('#profile button').prop("disabled", false);
                $('#success').removeClass('hidden')
                setTimeout(() => {
                    $('#success').addClass('hidden')
                }, 2000)
            }, error => {
                this.message = error.response.data.message
                $('#message').removeClass('hidden')
                setTimeout(() => {
                    $('#message').addClass('hidden')
                }, 5000)
                $('#profile button').prop("disabled", false);
            })
        },
    }
    
}
</script>